import * as moment from "../../../node_modules/moment/moment";

export class PersonalDataDetails {
    private _name: string;
    private _firstSurname: string;
    private _secondSurname: string;
    private _NIF: string;
    private _nationality: string;
    private _nationalityCode: number;
    private _dateOfBirth: Date;
    private _gender: number;
    private _fullNameToView: string;

    constructor(data: any) {
        this._name = data.name;
        this._firstSurname = data.firstSurname;
        this._secondSurname = data.secondSurname;
        this._NIF = data.nif;
        this._nationality = data.nationality;
        this._nationalityCode = data.nationalityCode;
        this._dateOfBirth = data.dateOfBirth ? moment.utc(data.dateOfBirth).toDate() : null;
        this._gender = data.gender;
        this._fullNameToView = this.setFullName();
    }

    public get name() {
        return this._name;
    }
    public set name(name: string) {
        this._name = name;
    }

    public get firstSurname() {
        return this._firstSurname;
    }
    public set firstSurname(firstSurname: string) {
        this._firstSurname = firstSurname;
    }

    public get secondSurname() {
        return this._secondSurname;
    }
    public set secondSurname(secondSurname: string) {
        this._secondSurname = secondSurname;
    }

    public get NIF() {
        return this._NIF;
    }
    public set NIF(NIF: string) {
        this._NIF = NIF;
    }

    public get nationality() {
        return this._nationality;
    }
    public set nationality(nationality: string) {
        this._nationality = nationality;
    }
    
    public get nationalityCode() {
        return this._nationalityCode;
    }
    public set nationalityCode(nationalityCode: number) {
        this._nationalityCode = nationalityCode;
    }
    
    public get dateOfBirth() {
        return this._dateOfBirth;
    }

    public set dateOfBirth(dateOfBirth: Date) {
        this._dateOfBirth = new Date(dateOfBirth);
    }

    public get gender() {
        return this._gender;
    }
    public set gender(gender: number) {
        this._gender = gender;
    }

    public get fullNameToView() {
        return this._fullNameToView;
    }

    public updateNationality(nationalities) {
        this._nationality = nationalities.find(element => element.key === this._nationalityCode).value;
    }

    public setFullName() {
        const surnames = this.firstSurname + ' ' + this.secondSurname;
        return surnames.trim() + ', ' + this.name;
    }

    public toServer() {
        const dateOfBirthFormatted = moment.utc(this._dateOfBirth).format('L');
        return {
            name: this._name,
            firstSurname: this._firstSurname,
            secondSurname: this._secondSurname,
            NIF: this._NIF,
            nationality: this._nationality,
            nationalityCode: this._nationalityCode,
            gender: this._gender,
            dateOfBirth: this._dateOfBirth ? moment.utc(dateOfBirthFormatted, 'L').toISOString() : null
        };
    }
}
